/*
Place this widget just before the closing tag of the .Article__Main element
*/

import Widget from "./base.js";
import { getCookie } from "tpm-utils";

export class MembershipDriveCount25Widget extends Widget {
	componentWillMount() {
		this.state.total = "    ";
		this.fetchTotal();
	}

	fetchTotal() {
		return fetch(
			`https://accounts.${document.location.hostname}/membership-drive.json`,
			{
				method: "GET",
				credentials: "omit",
			}
		)
			.then((response) => response.json())
			.then((data) => {
				this.setState({
					total: String(data.bindings.membership_drive.newMembers).padStart(
						4,
						"0"
					),
				});
			})
			.catch((r) => {
				console.log("MembershipDriveCard24Widget.fetchTotal error", r);
			});
	}

	href() {
		const source = "on_site";
		const campaign = "prime_drive_24";
		let medium = "below_article";
		if (this.isBumper) medium = "modal_article";
		const promo = "&promo=25offAny";

		return `${document.location.origin}/memberships?utm_source=${source}&utm_medium=${medium}&utm_campaign=${campaign}${promo}`;
	}

	renderContent() {
		return (
			<div className={`MembershipDriveCountWrapper --${this.props.logoPos}`}>
				<div
					className={`MembershipDriveCount --${this.props.color} --${this.props.size} `}
				>
					{this.state.total.split("").map((n, i) => (
						<div className="coin" key={i}>
							<div className="back">{n}</div>
							<div className="front"></div>
						</div>
					))}
				</div>

				<img
					className={`MembershipDriveCountWrapper__Logo --${this.props.logoPos}`}
					src={`${document.location.origin}/wp-content/themes/tpm25//assets/images/membership-drive-26/logo.png`}
					alt="TPM Member Drive"
				></img>
			</div>
		);
	}
}
